#import "./TaxedPriceFull.graphql"

fragment OrderPricesFull on OrderPrices {
  exchangeRate
  appliedDiscounts {
    deliveryPrice
    discountsByTaxRate {
      ...TaxedPriceFull
    }
  }
  deliveryPrice {
    withoutTax
    withTax
  }
  roundingAdjustment
  totalPrice {
    withoutTax
    withTax
  }
}
